export interface PdfRenderProfile {
  /** html2canvas scale for text/contract pages. */
  scale: number
  /** JPEG quality for text/contract pages. */
  jpegQuality: number
  /** html2canvas scale for pages holding customer photos. */
  photoPageScale: number
  /** JPEG quality for pages holding customer photos. */
  photoPageJpegQuality: number
  /** Longest side (px) a customer photo is inlined at before capture. */
  maxPhotoSide: number
  /** JPEG quality for inlined customer photos; undefined keeps PNG. */
  photoInlineJpegQuality?: number
}

// Manual "Download PDF": the long-standing values, unchanged.
export const DOWNLOAD_PDF_PROFILE: PdfRenderProfile = {
  scale: 2,
  jpegQuality: 0.92,
  photoPageScale: 2,
  photoPageJpegQuality: 0.92,
  maxPhotoSide: Infinity,
}

// Guided Finish email attachment. A roof claim packet carries every photo
// section (9 photos per page); at the download values each photo page is
// ~1-2.5MB and the base64 body crossed the backend's 20mb /send-contract
// limit (413 -> opaque 500 -> "could not be confirmed", 2026-10-24).
// Text stays legible at 1.5x/0.8; photo pages drop further because the
// photos are thumbnails in a 3x3 grid (~230px wide on an 800px page).
export const EMAIL_PDF_PROFILE: PdfRenderProfile = {
  scale: 1.5,
  jpegQuality: 0.8,
  photoPageScale: 1.25,
  photoPageJpegQuality: 0.7,
  maxPhotoSide: 1000,
  photoInlineJpegQuality: 0.85,
}

export function fitWithin(
  width: number,
  height: number,
  maxSide: number,
): { width: number; height: number } {
  const longest = Math.max(width, height)
  if (!(longest > maxSide)) return { width, height }
  const ratio = maxSide / longest
  return {
    width: Math.max(1, Math.round(width * ratio)),
    height: Math.max(1, Math.round(height * ratio)),
  }
}
